// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NkdJ","type":"styles_type__2XD-C","choices":"styles_choices__C_rbj"};